export default "/images/889dca90ad1e9412f478d9ce63a3e526.avif";